<template>
  <table class="table is-bordered printable-check-list-summary" v-if="checkList">
    <tbody>
      <tr>
        <th colspan="2">
          {{ checkList.name }}
          <div v-if="checkList.description.length" class="desc">{{ checkList.description }}</div>
        </th>
      </tr>
      <tr v-if="checkList.user">
        <th>Completed By</th>
        <td>{{ checkList.user }}</td>
      </tr>
      <tr v-if="checkList.timestampStarted">
        <th>Started</th>
        <td>{{ checkList.timestampStarted | unixToDateTimeString }}</td>
      </tr>
      <tr v-if="checkList.timestampEnded">
        <th>Ended</th>
        <td>{{ checkList.timestampEnded | unixToDateTimeString }}</td>
      </tr>
      <tr v-if="checkList.timestampStarted && checkList.timestampEnded">
        <th>Duration</th>
        <td>{{ checkList.timestampEnded - checkList.timestampStarted | prettySeconds }}</td>
      </tr>
      <tr v-for="(c, index) in checkList.checks" :key="'check-' + index">
        <th>{{ c.name }}</th>
        <td>
          <template v-if="c.type === 'checkbox'">
            <template v-if="c.value === 'yes'">
              <font-awesome-icon icon="check" />
            </template>
            <template v-else-if="c.value === 'no'">
              <font-awesome-icon icon="times" />
            </template>
            <template v-else>
              {{ c.value }}
            </template>
          </template>
          <template v-else>
            <div class="nl">{{ c.value }}</div>
          </template>
          <div v-if="c.comment && c.comment.length">
            <span class="nl">{{ c.comment}}</span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'PrintableCheckListSummary',
  props: ['checkList']
}
</script>

<style>
  table.printable-check-list-summary .desc {
    margin-top: 10px;
    font-weight: normal;
  }
</style>
